import { isFunction } from '../utils';
import { VERSION } from '../version';
export function initializeMetas(internalLogger, config) {
    var _a;
    let items = [];
    let listeners = [];
    const getValue = () => items.reduce((acc, item) => Object.assign(acc, isFunction(item) ? item() : item), {});
    const notifyListeners = () => {
        if (listeners.length) {
            const value = getValue();
            listeners.forEach((listener) => listener(value));
        }
    };
    const add = (...newItems) => {
        internalLogger.debug('Adding metas\n', newItems);
        items.push(...newItems);
        notifyListeners();
    };
    const remove = (...itemsToRemove) => {
        internalLogger.debug('Removing metas\n', itemsToRemove);
        items = items.filter((currentItem) => !itemsToRemove.includes(currentItem));
        notifyListeners();
    };
    const initial = {
        sdk: {
            name: '@grafana/faro-core',
            version: VERSION,
            integrations: config.instrumentations.map(({ name, version }) => ({ name, version })),
        },
    };
    if (config.app) {
        initial.app = config.app;
    }
    if (config.user) {
        initial.user = config.user;
    }
    add(initial, ...((_a = config.metas) !== null && _a !== void 0 ? _a : []));
    const addListener = (listener) => {
        listeners.push(listener);
    };
    const removeListener = (listener) => {
        listeners = listeners.filter((l) => l !== listener);
    };
    return {
        add,
        remove,
        addListener,
        removeListener,
        get value() {
            return getValue();
        },
    };
}
//# sourceMappingURL=initialize.js.map